module.exports = __webpack_public_path__ + "media/חלון.99cde410.mp3";